import Vue from "vue";
import _window, { getOnlyStringLog } from "@src/libraries/window";
import LocalStorage from "@src/libraries/LocalStorage";
import { windowLoad, timeout, isProduction, deepCopy } from "@src/assets/js/utils";
if (!process.client && isProduction()) {
    console.log = doNothing;
    console.warn = doNothing;
}
const consoleLog = console.log;
const consoleWarn = console.warn;
export const LOG_ARR = [];
function logArr(...args) {
    if (!process.client)
        return;
    const coumputedLog = args[0] && (args[0].includes("%ccomputed") || args[0].includes("%cdata"));
    if (!coumputedLog) {
        LOG_ARR.push(getOnlyStringLog(args));
    }
}
const debugStore = new Vue({
    name: "Debug",
    data() {
        const data = {};
        return data;
    },
    computed: {
        tester() {
            const meId = this.meId;
            if (!meId)
                return false;
            const testers = [
                52,
                18863,
                3,
                4,
                5,
                98,
                3146,
                25324,
                24197,
                26729,
            ];
            return testers.includes(meId);
        },
        alpha() {
            const tester = this.tester;
            if (tester)
                return true;
            return isAlphaLocation();
        },
        beta() {
            const admin = 1 == this.meId;
            const tester = this.tester;
            if (admin || tester)
                return true;
            return isBetaLocation();
        },
        debug() {
            const alpha = this.alpha;
            if (alpha)
                return true;
            if (!isProduction())
                return true;
            return false;
        },
        hideLogs() {
            const alpha = this.alpha;
            const beta = this.beta;
            if (!process.client)
                return false;
            if (location.hash.includes("logs="))
                return false;
            if (alpha || beta)
                return false;
            if (!isProduction())
                return false;
            return true;
        }
    },
    asyncComputed: {
        meId: {
            lazy: true,
            async get() {
                try {
                    return (await import("@src/store/users")).default.meId;
                }
                catch (e) { }
                ;
            }
        }
    },
    watch: {
        hideLogs: {
            immediate: true,
            handler(hide) {
                if (!isProduction())
                    return;
                if (hide) {
                    console.log("DISABLED LOGS");
                    console.log = (...args) => {
                        try {
                            logArr(...args);
                        }
                        catch (e) {
                        }
                    };
                    console.warn = doNothing;
                }
                else {
                    console.log = (...args) => {
                        consoleLog(...args);
                        try {
                            logArr(...args);
                        }
                        catch (e) {
                        }
                    };
                    console.warn = consoleWarn;
                    console.log("ENABLED LOGS");
                }
            }
        }
    }
});
export default debugStore;
export async function moduleDebug(module, notWatch) {
    if (!process.client)
        return;
    await timeout(1);
    const debug = debugStore && debugStore.debug;
    if (!debug)
        return;
    if (!notWatch) {
        module.$watch("$data", {
            handler: function (data, oldVal) {
                try {
                    if (!this._priorState) {
                        try {
                            this._priorState = this.$options.data();
                        }
                        catch (e) {
                            this._priorState = { ...data };
                            return;
                        }
                    }
                    let changedProp;
                    for (const key in data) {
                        if (deepCopy(data[key]) != deepCopy(this._priorState[key])) {
                            changedProp = key;
                            break;
                        }
                    }
                    if (changedProp) {
                        console.log("%cdata", "color:#009954", changedProp, this._priorState[changedProp], "->", data[changedProp]);
                    }
                    this._priorState = { ...data };
                }
                catch (e) {
                    console.log("debug watch", e);
                }
            },
            deep: true
        });
    }
    const name = module.$options.name;
    const computed = module._computedWatchers;
    for (const key in computed) {
        (function () {
            const original = computed[key].getter;
            computed[key].getter = function () {
                console.log("%ccomputed", "color:#009954", name, key);
                return original.apply(this, arguments);
            };
        })();
    }
    const document = _window.document;
    document && windowLoad().then(function () {
        module.$mount(document.body.appendChild(document.createElement("div")));
    });
}
moduleDebug(debugStore);
function isAlphaLocation() {
    if (LocalStorage.getItem("alpha")) {
        return true;
    }
    const location = _window.location;
    if (location && location.search.includes("alpha=1")) {
        return true;
    }
    return false;
}
function isBetaLocation() {
    if (LocalStorage.getItem("beta")) {
        return true;
    }
    const location = _window.location;
    if (!location) {
        return false;
    }
    if (location.search.includes("beta=1")) {
        return true;
    }
    return false;
}
function doNothing() {
}
